import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/** Legacy route — redirects to the signed-in feed at /events. */
export default function MyEventsPage() {
  const { account, checking } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!checking) nav("/events", { replace: true });
  }, [checking, nav]);

  if (checking || account === false) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <p className="font-display font-bold text-[18px]">Loading…</p>
      </div>
    );
  }

  return null;
}
